<template>
  <div class="section py-0">
    <div class="section pb-0">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-gold is-outlined"
            icon-left="plus"
            @click="tagModalOpen = true"
          >
            Tag verfassen
          </b-button>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-input
              v-model="search"
              placeholder="Tag suchen..."
              type="search"
              icon-pack="fas"
              icon="search"
            >
            </b-input>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-select v-model="rangeRows">
              <option value="20">20 pro Seite</option>
              <option value="50">50 pro Seite</option>
              <option value="100">100 pro Seite</option>
              <option value="500">500 pro Seite</option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-narrow">
          <b-dropdown
            :triggers="['hover']"
            aria-role="list"
            position="is-bottom-left"
          >
            <template #trigger>
              <b-button type="is-gold is-outlined" icon-right="caret-down">
                Aktionen
              </b-button>
            </template>

            <b-dropdown-item @click="confirmSetComoon"
              >Mark as commonly search</b-dropdown-item
            >
            <b-dropdown-item @click="confirmBulkDelete"
              >Löschen</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="section">
      <b-table
        icon-pack="fa"
        :data="filteredTag"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        :paginated="filteredTag.length > 20"
        :per-page="rangeRows"
        hoverable
      >
        <b-table-column field="name" label="Name" sortable v-slot="{ row }">
          {{ row.name }}
        </b-table-column>

        <b-table-column
          field="commonly_searched"
          label="Commonly Searched"
          sortable
          v-slot="{ row }"
        >
          {{ row.commonly_searched ? "Yes" : "No" }}
        </b-table-column>
        <b-table-column field="action" label="" width="40" v-slot="{ row }">
          <router-link :to="{ name: 'ViewTag', params: { tagId: row.id } }">
            <b-icon icon="arrow-right" />
          </router-link>
        </b-table-column>
      </b-table>
    </div>
    <b-modal
      v-model="tagModalOpen"
      :destroy-on-hide="false"
      has-modal-card
      trap-focus
      class="tagModal"
      :class="{ 'is-loading': $store.getters.isLoading }"
    >
      <template #default="props">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Tag erstellen</p>
          </header>
          <div class="modal-card-body">
            <TagEdit
              :tag="tagModel"
              @submitted="submitTag"
              @close="props.close"
            />
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapGetters } from "vuex";
import helper from "@/functions/helper";
import TagEdit from "@/components/editProduct/TagEdit.vue";

export default {
  name: "AllTags",
  components: {
    TagEdit
  },
  data() {
    return {
      search: "",
      checkedRows: [],
      rangeRows: 20,
      tagModalOpen: false,
      selectedTagId: null
    };
  },
  computed: {
    ...mapGetters({
      tags: "tag/data",
      theTag: "tag/dataById",
      loadingTag: "tag/loading"
    }),
    filteredTag() {
      return helper.search(this.tags, ["name"], this.search);
    },
    tagModel() {
      return this.selectedTagId
        ? this.theTag(this.selectedTagId)
        : { name: "", commonly_searched: false };
    }
  },
  methods: {
    submitTag(payload) {
      this.$store.dispatch(`tag/CREATE`, payload);
      this.tagModalOpen = false;
    },
    confirmSetComoon() {
      this.$buefy.dialog.confirm({
        title: "Mark Tags as Commonly Searched",
        // eslint-disable-next-line max-len
        message: "Do you want to set all selected tags as commonly searched?",
        confirmText: "Yes",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.setCommon)
      });
    },
    confirmBulkDelete() {
      this.$buefy.dialog.confirm({
        title: "Tag löschen",
        // eslint-disable-next-line max-len
        message:
          "Sind Sie sicher, dass Sie alle ausgewählen Tag löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden!",
        confirmText: "Tag löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.deleteTag)
      });
    },
    setCommon({ id, name }) {
      this.$store.dispatch("tag/UPDATE", {
        id,
        name,
        commonly_searched: true
      });
    },
    deleteTag({ id }) {
      this.$store.dispatch("tag/DELETE", { id });
    },
    bulkAction(action) {
      this.checkedRows.forEach(action);
      this.checkedRows = [];
    }
  }
};
</script>
<style>
.modal.is-active.is-loading .modal-background {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
